export const apiHost = `https://www.int.dev.cox.com`
